import { createAttribute, fetchProductAttributes } from "@/modules/offers/api/productModeration"
import type { AttributeFormLocale } from "@/modules/offers/types/createOffer"
import type {
  CreateAttributePayload,
  CreateAttributeResponse
} from "@/modules/offers/types/productModeration"

export const findOrCreateAttribute = async (
  publicName: Record<AttributeFormLocale, string>
): Promise<CreateAttributeResponse> => {
  const pageSize = 10
  let page = 1

  while (true) {
    const { data } = await fetchProductAttributes({
      queryParams: { public_name: publicName.uk, page, pageSize }
    })
    const existingAttribute = data.results.find(
      (attribute) => attribute.public_name_mlang?.uk === publicName.uk
    )

    if (existingAttribute) return existingAttribute

    if (page * pageSize >= data.count) break

    page += 1
  }

  const payload: CreateAttributePayload = { public_name_mlang: { ...publicName } }
  const { data } = await createAttribute({ payload })
  return data
}
